// @ts-check
// Lista de abas (doc 07, seção 9): 40 px, gap 4, sublinhado de 1 px na aba ativa.
import { html } from 'htm/preact';
import { Icon } from './icon.js';

/**
 * @param {{ tabs: { id: string, title: string, icon?: string, pill?: string | number | null }[], activeTabId: string, onChange: (tabId: string) => void }} props
 */
export function TabList({ tabs, activeTabId, onChange }) {
  return html`<div class="tab-list" role="tablist">
    ${tabs.map(
      (tab) => html`<button
        type="button"
        role="tab"
        id=${`tab-${tab.id}`}
        class="tab-button"
        aria-selected=${tab.id === activeTabId ? 'true' : 'false'}
        data-active=${tab.id === activeTabId ? 'true' : undefined}
        onClick=${() => onChange(tab.id)}
      >
        <span class="tab-button-content">
          ${tab.icon ? html`<${Icon} name=${tab.icon} size=${16} />` : null}
          <span>${tab.title}</span>
          ${tab.pill !== undefined && tab.pill !== null ? html`<span class="pill">${tab.pill}</span>` : null}
        </span>
      </button>`,
    )}
  </div>`;
}
